import { render, staticRenderFns } from "./ConsumersWithoutSalons.vue?vue&type=template&id=1da9f3a2&scoped=true"
import script from "./ConsumersWithoutSalons.vue?vue&type=script&lang=js"
export * from "./ConsumersWithoutSalons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da9f3a2",
  null
  
)

export default component.exports